export class DeviceCommand {
    serial: string;
    index: number;
    command: string;
    mode: number;
    code: string;
}
